import React, { useState } from "react";
import Modal from "../footer/Modal";
import "./cookieBanner.css";
const CookieBanner = () => {
  const [acceptedCookies, setAcceptedCookies] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const acceptCookies = () => {
    setAcceptedCookies(true);
  };

  if (acceptedCookies) {
    return null;
  }

  return (
    <div className="cookie-banner">
      <p>
        This website may use cookies to ensure you get the best experience on
        our website. Read more about our privacy policy{" "}
        <span onClick={() => setIsOpen(true)} className="link">
          here
        </span>
      </p>
      <div className="buttons-container">
        <button className="accept" onClick={acceptCookies} id="accept-cookies">
          Accept
        </button>
        <button className="decline" onClick={acceptCookies}>
          Decline
        </button>
      </div>

      <Modal open={isOpen} onClose={() => setIsOpen(false)}></Modal>
    </div>
  );
};

export default CookieBanner;
